module.exports = __webpack_public_path__ + "img/fruit_lemon.76c1fae6.png";